import dagre from '@dagrejs/dagre';
import { NODE_WIDTH, STEP_HEIGHT, TASK_STEP_HEIGHT, TRIGGER_HEIGHT, LAYOUT_GAP_Y } from './constants';

const DEFAULT_STEP_H = STEP_HEIGHT;
const DEFAULT_TASK_STEP_H = TASK_STEP_HEIGHT;
const DEFAULT_TRIGGER_H = TRIGGER_HEIGHT;

const getNodeHeight = (node) => {
    if (node.measured?.height) return node.measured.height;
    if (node.type === 'trigger') return DEFAULT_TRIGGER_H;
    return node.data?.step?.stepType === 'TASK' ? DEFAULT_TASK_STEP_H : DEFAULT_STEP_H;
};

export function autoLayout(nodes, edges, { direction = 'TB' } = {}) {
    const g = new dagre.graphlib.Graph();
    g.setDefaultEdgeLabel(() => ({}));
    g.setGraph({ rankdir: direction, nodesep: 70, ranksep: LAYOUT_GAP_Y, marginx: 40, marginy: 40 });

    const laidOut = nodes.filter(n => n.type === 'step' || n.type === 'trigger');
    laidOut.forEach(n => {
        const width = n.measured?.width ?? NODE_WIDTH;
        const height = getNodeHeight(n);
        g.setNode(n.id, { width, height });
    });

    edges.filter(e => e.type === 'pathEdge').forEach(e => {
        g.setEdge(e.source, e.target);
    });

    dagre.layout(g);

    const positions = {};
    laidOut.forEach(n => {
        const p = g.node(n.id);
        if (!p) return;
        const width = n.measured?.width ?? NODE_WIDTH;
        const height = getNodeHeight(n);
        positions[n.id] = { x: p.x - width / 2, y: p.y - height / 2 };
    });
    return positions;
}
